module.exports = __webpack_public_path__ + "img/bg-desktop-graphic.49585f56.svg";